import { NO_VALUE_OPERATORS } from '@modules/queryBuilder/constants';
import { NormalisedNode } from 'v2/querybuilder/types/querystore';

export function hasIncompleteFilters(
  nodes: Record<string, NormalisedNode>,
): boolean {
  return Boolean(
    Object.values(nodes).find((node): boolean => {
      if (node.type !== 'filter' || node.field === '') {
        return false;
      }
      if (NO_VALUE_OPERATORS.includes(node.operator)) {
        return false;
      }
      switch (node.value.type) {
        case 'string[]':
        case 'number[]':
        case 'boolean[]':
          return node.value.values.length === 0;
        default:
          return typeof node.value.value === 'undefined';
      }
    }),
  );
}
